import { playLobbyJoinSound } from 'utils/audio/playLobbyJoinSound';

class LobbyJoinSoundManager {
  private timeout: number | null = null;

  private readonly BATCH_DELAY = 2000;

  private hasPlayedRecently = false;

  /**
   * Triggers lobby join sound with leading debounce.
   * Plays immediately on first call, then ignores subsequent calls until timeout expires.
   */
  triggerSound = () => {
    if (!this.hasPlayedRecently) {
      playLobbyJoinSound();
      this.hasPlayedRecently = true;

      this.timeout = window.setTimeout(() => {
        this.hasPlayedRecently = false;
        this.timeout = null;
      }, this.BATCH_DELAY);
    }
  };

  reset = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.hasPlayedRecently = false;
  };
}

export const lobbyJoinSoundManager = new LobbyJoinSoundManager();
